export function validateEmail(value: string): string {
    const _value = value.trim().toLowerCase();

    if (_value.length === 0) {
        return 'shared.fields.email.error_required';
    }

    if (
        !_value.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
        return 'shared.fields.email.error_invalid';
    }

    return '';
}
